import React from 'react';
import PropTypes from 'prop-types';
// import './ScoreSlider.css'; 

const ScoreSlider = ({ 
  name, 
  score, 
  savedBackground, 
  handleChange, 
  sliderGenerator, // Pass the startSlider function here
  max = "10" 
}) => {
  
  // Logic moved inside: Determine if we have an active score
  const hasScore = score !== null && score !== undefined && score !== "";
  
  // Logic moved inside: Calculate the background
  const backgroundStyle = hasScore
    ? sliderGenerator(score, max)
    : (savedBackground || '');

  return (
    <input
      className={`weekSlider ${hasScore ? '' : 'off'}`}
      type="range"
      name={name}
      min="0"
      max={max}
      step="0.1"
      // Controlled value: fallback to "0" if empty
      value={hasScore ? score : "0"} 
      onChange={handleChange}
      style={{
        background: backgroundStyle
      }}
    />
  );
};

ScoreSlider.propTypes = {
  name: PropTypes.string.isRequired,
  score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  savedBackground: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  sliderGenerator: PropTypes.func.isRequired,
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ScoreSlider;